import React from 'react';
import { useMapEditor } from '../../../../contexts/MapEditorContext';
import { DragNumberInput } from '../../../controls/ScrollDragNumberInput';
import { PanelSectionWrapper } from '../PanelSectionWrapper';
import { ShapeSectionOptions } from '../ShapePanel';

export const CommonPositionPanelControls: React.FC<ShapeSectionOptions> = ({
  shapes
}) => {
  const { updateShape } = useMapEditor();
  const shape = shapes[0];

  const handleXChangeValue = (value: number | string) => {
    shapes.forEach((shape) => {
      updateShape(shape.id, { x: Number.parseInt(String(value)) });
    });
  };

  const handleYChangeValue = (value: number | string) => {
    shapes.forEach((shape) => {
      updateShape(shape.id, { y: Number.parseInt(String(value)) });
    });
  };

  const handleRotationChange = (value: number | string) => {
    shapes.forEach((shape) => {
      updateShape(shape.id, { rotation: Number.parseInt(String(value)) });
    });
  };

  return (
    <PanelSectionWrapper title={'Position'}>
      <div className={'flex gap-2'}>
        <div className="flex flex-col gap-1">
          <div className="text-sm font-medium">Left</div>
          <DragNumberInput
            size={'sm'}
            value={shape.x}
            onChange={handleXChangeValue}
          />
        </div>
        <div className="flex flex-col gap-1">
          <div className="text-sm font-medium">Top</div>
          <DragNumberInput
            size={'sm'}
            value={shape.y}
            onChange={handleYChangeValue}
          />
        </div>
      </div>
      <div className={'flex gap-2'}>
        <div className="flex flex-col gap-1">
          <div className="text-sm font-medium">Rotation</div>
          <DragNumberInput
            size={'sm'}
            value={Number(shape.rotation || 0)}
            onChange={handleRotationChange}
            max={360}
            min={-360}
          />
        </div>
        <div className="flex flex-col gap-1" />
      </div>
    </PanelSectionWrapper>
  );
};
